import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ButtonDropdown,
  Col,
  DropdownMenu,
  DropdownToggle,
  Label,
  Row,
} from "reactstrap";
import { CalenderIcon } from "../../Icon";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LockBlackIcon, LockRedIcon } from "../../../assets/images";
import "./lockEntries.scss";
import { formatDate } from "../../../utils/commonFunctions";

type AppProps = {
  handleSubmitLockEntry: (data: string) => void;
  lockedEntriesDate: null | string;
};

const LockEntryModal = ({
  handleSubmitLockEntry,
  lockedEntriesDate,
}: AppProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [date, setDate] = useState<any>(null);

  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleSetDate = (data: any) => {
    setDate(data);
  };

  useEffect(() => {
    if (!!lockedEntriesDate) {
      let newLockedDate = lockedEntriesDate?.split("-");
      let newDate = new Date(
        +newLockedDate[2],
        +newLockedDate[1] - 1,
        +newLockedDate[0]
      );
      setDate(newDate);
    } else {
      setDate(null);
    }
  }, [lockedEntriesDate]);

  return (
    <>
      <ButtonDropdown
        isOpen={showDropdown}
        toggle={toggleShowDropdown}
        className="lock-btn"
        style={
          showDropdown
            ? {
                color: "#dd4433",
                backgroundColor: "#fff6f5",
              }
            : {}
        }
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">Lock Entries</Tooltip>
          }
        >
          <DropdownToggle
            caret
            outline
            style={
              showDropdown
                ? {
                    color: "#dd4433",
                    backgroundColor: "#fff6f5",
                  }
                : { border: "1px solid#bfcbe1" }
            }
          >
            <img
              src={showDropdown ? LockRedIcon : LockBlackIcon}
              alt="Lock Icon"
            />
          </DropdownToggle>
        </OverlayTrigger>
        <DropdownMenu right>
          <div className="lock-dropdown p-3">
            <h4>Lock Entries Up To</h4>
            <Row>
              <Col md={12} className="form-group">
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={
                          !!date && date != "Invalid Date" ? date : null
                        }
                        onChange={handleSetDate}
                        selectsStart
                        showMonthDropdown
                        showYearDropdown
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="text-right">
                <button
                  className="btn btn-outline-secondary mr-3"
                  onClick={toggleShowDropdown}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!date}
                  onClick={() => {
                    date && handleSubmitLockEntry(formatDate(date));
                    setShowDropdown(!showDropdown);
                  }}
                >
                  Lock
                </button>
              </Col>
            </Row>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
    </>
  );
};

export default LockEntryModal;
